/** The actual catalog item stays beside the question; identifiers are never the merchant's job. */
import type { KnowledgeCatalogItem } from '@testfeed/integration-contracts'
import type { ReactNode } from 'react'
import { storeKnowledgeCopy as copy } from '@testfeed/product-language'
import { buildShopifyAdminProductUrl } from '../../shopify-admin-product-url'
import { useAppBridge } from '@shopify/app-bridge-react'
import { trackShopifyAction } from '../../shopifyUiTracking'
export function KnowledgeProduct({ item, children }: { item: KnowledgeCatalogItem; children?: ReactNode }) {
  const shopify = useAppBridge()
  const productUrl = buildShopifyAdminProductUrl(item.subject.productId, item.subject.variantId)
  const name = item.productTitle ?? item.title ?? copy.unnamed
  let title = <s-text type="strong">{name}</s-text>
  if (productUrl)
    title = (
      <s-link
        href={productUrl}
        target="_top"
        onClick={() => trackShopifyAction(shopify, 'open-admin-entity', () => undefined)}
      >
        {name}
      </s-link>
    )
  let image = null
  if (item.imageUrl)
    image = <s-thumbnail src={item.imageUrl} alt={item.productTitle ?? item.title ?? copy.unnamed} size="large" />
  let variant = null
  if (item.subject.variantId && item.title && item.title !== 'Default Title')
    variant = <s-text color="subdued">{item.title}</s-text>
  return (
    <s-grid gridTemplateColumns="auto minmax(0, 1fr)" gap="base" alignItems="start">
      {image}
      <s-stack gap="small">
        {title}
        {variant}
        {children}
      </s-stack>
    </s-grid>
  )
}
